import api from "./api";

const externalIntegrations = {
    getExternalIntegrations(query) {
        return api.get('/external-integrations', { params: query});
    },

    getHeadHunter(query) {
        return api.get('hh/integrations', { params: query});
    },

    getHeadHunterOptions(id, type, query) {
        if(query || type === 'managers') {
            return api.get(`hh/integrations/${id}/suggests/${type}?text=${query}`);
        } else {
            return api.get(`hh/integrations/${id}/${type}`);
        }
    },
    publishHeadHunter(vacancy_id, body) {
        return api.post(`/vacancies/${vacancy_id}/publish-hh-vacancy`, body);
    },

    addExternalIntegrations(body) {
        return api.post(`/external-integrations`, body);
    },
    addHeadHunterIntegration() {
        return api.get(`/hh/auth-link`);
    },

    deleteExternalIntegrations(id) {
        return api.delete(`/external-integrations/${id}`);
    },
    deleteHeadHunter(id) {
        return api.delete(`/hh/integrations/${id}`);
    },


    getAvitoVacanciesListAvito(query) {
        if (!!query) return api.get(`/avito/vacancies?search=${query}&limit=100`);
        else return api.get("/avito/vacancies");
    },

    getAvitoVacanciesListHeadHunter(query) {
        if (!!query) return api.get(`/hh/vacancies?search=${query}`);
        return api.get("/hh/vacancies");
    },

    getUrlInstructions() {
        return api.get('/external-integrations/instructions');
    },


    updateExternalIntegrations(body, id) {
        return api.post(`/external-integrations/${id}`, body);
    },
    updateHeadHunter(body, id) {
        return api.post(`/hh/integrations/${id}/auth-link`, body);
    }
};

export default externalIntegrations;
